const nl = {
  // Navigation
  nav_home: "Thuis",
  nav_explore: "Ontdekken",
  nav_workspace: "Werkruimte",
  ws_videos: "video's",
  ws_untitled: "Naamloze video",
  // A generation that failed. The card carries these until it is dismissed.
  ws_failed_title: "Video mislukt",
  ws_failed_refunded: "Uw tegoed is geretourneerd",
  ws_failed_dismiss: "Afwijzen",
  ws_failed_retry: "Probeer het opnieuw",
  ws_failed_retrying: "Beginnen…",
  ws_failed_banner_one: "Er kon geen video worden gegenereerd",
  ws_failed_banner_many: "{n} video's zijn mislukt",
  ws_failed_banner_body: "Er werd niets in rekening gebracht; het tegoed werd teruggestort op uw rekening. Probeer het opnieuw of kies een ander onderwerp.",
  ws_empty_title: "Hier nog niets.",
  ws_empty_body: "Elke video die je maakt, verschijnt hier, de nieuwste eerst.",
  ws_generate: "Genereer",
  ws_composer_placeholder: "Beschrijf een les\u2026",
  ws_placeholder_hw: "Geef de opdracht een naam… (optioneel)",
  ws_placeholder_lecture: "Noem de lezing… (optioneel)",
  ws_placeholder_self_study: "Wat wil je studeren?",
  nav_search: "Video's zoeken...",
  nav_search_yours: "Zoek je video's...",
  nav_notifications: "Meldingen",
  nav_mark_all_read: "Markeer alles als gelezen",
  nav_no_notifications: "Nog geen meldingen",
  nav_no_notifications_sub: "We laten het je weten wanneer je video's klaar zijn",
  nav_upgrade: "Upgraden",
  nav_billing: "Facturering",
  nav_settings: "Instellingen",
  nav_contact: "Neem contact met ons op",
  nav_api: "API",
  nav_sign_out: "Meld u af",
  nav_just_now: "Zojuist",
  nav_minutes_ago: "{n}m geleden",
  nav_hours_ago: "{n}u geleden",
  nav_days_ago: "{n}d geleden",
  nav_used_this_month: "{used} van {cap} gebruikt deze maand",
  // locale file, and this one is the obvious thing to reach for if a weekly bucket returns.
  nav_used_today: "{used} van {limit} gebruikt deze week",
  nav_free_daily: "4 gratis video's per week",
  // Settings
  settings_title: "Instellingen",
  settings_profile: "Profiel",
  settings_change_avatar: "Wijzig avatar",
  settings_cancel: "Annuleren",
  settings_choose_wizard: "Kies uw tovenaar",
  settings_display_name: "Weergavenaam",
  settings_your_name: "Jouw naam",
  settings_save: "Redden",
  settings_saving: "Besparing...",
  settings_saved: "Opgeslagen",
  settings_save_failed: "Kan niet opslaan",
  settings_email: "E-mail",
  settings_notifications: "Meldingen",
  settings_email_notif: "E-mailmeldingen",
  settings_email_notif_desc: "Ontvang updates en aankondigingen via e-mail",
  settings_language: "Taal",
  settings_language_desc: "Kies de taal voor de app en de videovertelling",
  settings_data_title: "Jouw gegevens",
  settings_data_desc: "Download een kopie van de persoonlijke gegevens die aan uw account zijn gekoppeld, inclusief uw profiel, video's, cursussen, sessies en ondersteuningsberichten. Interne systeemlogboeken en afgeleide verwerkingsgegevens zijn niet inbegrepen.",
  settings_data_download: "Mijn gegevens downloaden",
  settings_data_exporting: "Voorbereiden…",
  settings_danger: "Gevarenzone",
  settings_delete_account: "Account verwijderen",
  settings_delete_desc: "Verwijder uw account en alle bijbehorende gegevens definitief. Deze actie kan niet ongedaan worden gemaakt.",
  settings_delete_confirm: "Hiermee worden uw account en al uw gegevens definitief verwijderd. Typ {keyword} om te bevestigen.",
  settings_delete_placeholder: "Typ \"VERWIJDEREN\" om te bevestigen",
  settings_permanently_delete: "Permanent verwijderen",
  settings_deleting: "Verwijderen...",
  explore_watch_now: "Kijk nu",
  // One pair of strings per scene; the eyebrow and the button are shared.
  explore_no_preview: "Geen voorbeeld",
  explore_no_videos: "Er zijn nog geen video's beschikbaar. Kom snel terug!",
  explore_featured_courses: "Uitgelichte cursussen",
  course_lesson_count: "{n, plural, one {# lesson} other {# lessons}}",
  course_back_to_explore: "Terug naar Ontdekken",
  course_not_found: "Deze cursus is niet beschikbaar.",
  // Home Page
  home_hero: "Leer alles,",
  home_hero_accent: "visueel",
  home_placeholder: "Wat wil je leren of oplossen?",
  home_extracting: "Vragen uitpakken...",
  home_videos_generated: "Er worden {n, plural, one {# video} other {# video's}} gegenereerd",
  home_credits: "{n, plural, one {# tegoed} other {# tegoeden}}",
  home_remaining: "resteert deze maand",
  home_enter_prompt: "Vul in wat je wilt leren of oplossen",
  home_popular: "Populaire lessen",
  home_from_community: "Vanuit de gemeenschap",
  home_community_sub: "Kijk wat leerlingen maken",
  home_tips_label: "Van de Magische tovenaar",
  home_tips_title: "Tips en trucs",
  home_tip1_title: "Wees specifiek",
  home_tip1_desc: "Typ niet een heel onderwerp. Kies één idee, één concept, één vraag.",
  home_tip1_example: "Hoe DNA-replicatie werkt in eukaryotische cellen",
  home_tip2_title: "Zeg voor wie het is",
  home_tip2_desc: "Een uitleg op de middelbare school ziet er heel anders uit dan een college-lezing.",
  home_tip2_example: "Leg afgeleiden uit voor iemand die net algebra heeft geleerd",
  home_tip3_title: "Vertel Magi wat je wilt",
  home_tip3_desc: "Voorbeelden, stapsgewijze, toepassingen uit de echte wereld: zeg het gewoon en Magi zal volgen.",
  home_tip3_example: "De watercyclus met praktijkvoorbeelden en een samenvatting",
  home_tip_try: "Probeer zoiets als",
  home_proven_social: "Volg ons op Instagram",
  home_ig_desc_1: "Over",
  home_ig_followers: "55.000 volgers",
  home_ig_desc_2: "bekijk elke dag onze wiskunde- en wetenschapsvideo's op Instagram. Deze molens zijn gemaakt met dezelfde motor die je hier gebruikt.",
  home_view_profile: "Bekijk profiel",
  home_subscribe_now: "Abonneer je nu",
  home_sub_monthly: "Maandelijks",
  home_sub_yearly: "Jaarlijks",
  // goes false the moment either price moves, on the surface where that matters most.
  home_sub_yearly_save: "Bespaar {pct}%",
  home_sub_per_month: "/ maand",
  home_sub_billed_monthly: "maandelijks ${amount} gefactureerd",
  home_sub_processing: "Verwerken...",
  home_sub_no_commitment: "Geen verplichting. Annuleer op elk gewenst moment.",
  home_sub_secured: "Beveiligd door Stripe",
  home_sub_headline: "Ontgrendel meer met {plan}",
  home_sub_due_now: "Nu verschuldigd",
  home_sub_trial_label: "{days}-dag volledige toegang",
  // choosing the plan directly is owed exactly what a trialist is owed.
  home_sub_monthly_terms: "Er wordt vandaag ${amount} in rekening gebracht voor {n} video's deze maand. Op {date} wordt het verlengd voor ${amount}/maand, tenzij u eerst opzegt. U kunt het abonnement op elk gewenst moment opzeggen via Facturering.",
  // frequency, states that it happens automatically, and says where to cancel.
  home_sub_trial_terms: "Er wordt vandaag ${trial} in rekening gebracht voor {days} dagen volledige toegang, met een maximum van {n} video's. De proefperiode loopt niet door bij ${trial} — op {date} wordt het automatisch {planName} voor ${plan} per maand ({full} video's), en daarna wordt ${plan} elke maand in rekening gebracht totdat je het abonnement opzegt. Annuleer op elk gewenst moment via Facturering.",
  home_sub_card: "Credit- of debetkaart",
  home_sub_billed_once_yearly: "wordt één keer per jaar ${amount} gefactureerd",
  home_sub_billed_trial: "${amount} wordt gefactureerd voor {days} dagen en wordt vervolgens elke maand verlengd voor ${renews}",
  home_sub_switch_plan: "Op zoek naar {plan}?",
  home_sub_replaces_plan: "Vervangt uw {plan}-abonnement. Uw factuurdatum blijft hetzelfde. Als u omhoog gaat, wordt het verschil nu in rekening gebracht, terwijl u naar beneden gaat bij uw volgende verlenging.",
  home_sub_change_now: "Je zit nu op {plan} — {amount} afgerekend voor het verschil.",
  home_sub_change_later: "Je gaat op {date} over naar {plan}. Vandaag wordt niets afgerekend.",
  // the allowance changed; this one cannot.
  home_sub_feature_videos_n: "{n} video's per maand",
  // Pricing Page
  pricing_title: "Upgrade uw abonnement",
  pricing_monthly: "Maandelijks",
  pricing_yearly: "Jaarlijks",
  pricing_save: "Bespaar 17%",
  pricing_best_value: "Beste waarde",
  pricing_your_plan: "Uw huidige abonnement",
  pricing_get_started: "Ga aan de slag",
  pricing_processing: "Verwerken...",
  pricing_per_month: "/maand",
  pricing_billed_yearly: "Gefactureerd ${amount}/jaar",
  pricing_videos_month: "{n, plural, one {# video} other {# video's}}/maand",
  pricing_manage_cancel: "Beheer of annuleer",
  pricing_manage_unavailable: "We konden geen abonnement vinden om te beheren. Neem contact op, dan lossen we het op.",
  pricing_opening: "Opening...",
  billing_autorenew_monthly: "Wordt automatisch verlengd voor ${amount}/maand totdat je opzegt.",
  billing_autorenew_yearly: "Wordt automatisch verlengd voor ${amount}/jaar totdat je opzegt.",
  billing_autorenews_on: "Automatische verlenging op {date} · op elk gewenst moment opzeggen",
  pricing_secured: "Beveiligd door Stripe",
  pricing_login_required: "Log in om u te abonneren",
  pricing_auth_error: "Fout bij gebruikersauthenticatie. Probeer uit en weer in te loggen.",
  pricing_feature_pdf: "PDF- en afbeeldingsextractie",
  pricing_feature_quality: "Model van hogere kwaliteit",
  pricing_feature_speed: "Snellere generatietijd",
  pricing_feature_study: "Studiesessies",
  pricing_free_hint: "Momenteel met het gratis abonnement",
  // Billing Page
  billing_title: "Facturering",
  billing_current_plan: "Huidig ​​abonnement",
  billing_payment_failed_title: "Uw plan is onderbroken",
  billing_payment_failed_body: "We konden {amount} niet innen, dus uw abonnement is onderbroken. Update uw kaart om deze opnieuw te starten. We blijven het ook opnieuw proberen.",
  billing_payment_failed_cta: "Betaling herstellen",
  billing_change_plan: "Plan wijzigen",
  billing_invoices: "Facturen",
  billing_loading: "Facturen laden...",
  billing_no_invoices: "Nog geen facturen",
  billing_date: "Datum",
  billing_amount: "Hoeveelheid",
  billing_status: "Status",
  billing_invoice: "Factuur",
  billing_view: "Weergave",
  // Contact Page
  contact_title: "Neem contact met ons op",
  contact_placeholder: "Hoe kunnen wij helpen?",
  contact_sent_desc: "We nemen zo snel mogelijk contact met u op.",
  contact_signin: "Meld u aan om contact op te nemen met de ondersteuning.",
  // Generation Queue
  queue_title: "Wachtrij",
  queue_active: "{n} actief",
  queue_generating: "{n} genereren",
  queue_ready: "Klaar om te kijken",
  queue_in_queue: "Wachten in de wachtrij...",
  queue_almost_ready: "Bijna klaar...",
  queue_seconds_left: "Er zijn nog {n} over",
  queue_minutes_left: "{m}m {s}s over",
  queue_watch_now: "Kijk nu",
  queue_waiting: "Wachten in de rij...",
  queue_empty: "Er staan ​​geen video's in de wachtrij",
  queue_empty_sub: "Genereer een video om deze hier te bekijken",
  queue_clear: "Alles wissen",
  queue_total: "{n} totaal",
  queue_first_time: "Je video wordt gegenereerd",
  queue_first_time_sub: "Meestal ~2 minuten. Je hoort een bel als het klaar is.",
  // Session Expired
  session_expired: "Sessie verlopen",
  session_expired_desc: "Om veiligheidsredenen is uw sessie verlopen. Meld u opnieuw aan om door te gaan.",
  // Cookie Banner
  cookie_text: "We gebruiken cookies om het siteverkeer te analyseren en uw ervaring te verbeteren. Alleen essentiële cookies worden standaard ingesteld.",
  cookie_learn_more: "Meer informatie",
  cookie_accept: "Accepteer alles",
  cookie_reject: "Weiger niet-essentieel",
  // Create Project Modal
  create_new_project: "Nieuw project",
  create_extracting: "Extraheren...",
  create_select_problems: "Selecteer Problemen",
  create_select_topics: "Selecteer Onderwerpen",
  create_new_video: "Nieuwe video",
  create_new_hw: "Nieuw huiswerkproject",
  create_new_lecture: "Nieuw lezingenproject",
  create_new_self_study: "Nieuw project",
  create_video: "Video",
  create_homework: "Huiswerk",
  create_lecture: "Lezing",
  create_self_study: "Project",
  create_video_sub: "Genereer een video",
  create_hw_sub: "Huiswerk uploaden",
  create_lecture_sub: "Dia's uploaden",
  create_self_study_sub: "Kies uw onderwerpen",
  create_video_prompt: "Wat moet de video uitleggen?",
  create_project_title: "Projecttitel",
  create_video_hint: "Dit wordt gebruikt als titel en als prompt voor je video.",
  create_drop_hw: "Laat je huiswerk hier achter",
  create_drop_lecture: "Plaats hier uw lezingdia's",
  create_file_types: "PDF, PNG, JPG, HEIC",
  // Shown over the composer while a file is being dragged onto it.
  composer_drop_hint: "Ga naar beneden om een ​​project te starten",
  create_reading_hw: "Je huiswerk lezen",
  create_reading_lecture: "Je lezing lezen",
  create_finding_problems: "Problemen zoeken en eruit halen...",
  create_finding_topics: "Onderwerpen extraheren...",
  create_add_video: "Voeg nog een video toe",
  create_add_more_files: "Voeg meer bestanden toe",
  create_starting: "Beginnende generatie...",
  create_generate_video: "Genereer video \u00B7 1 credit",
  create_generate_n: "Genereer {n, plural, one {# video} other {# video's}} \u00B7 {n, plural, one {# tegoed} other {# tegoeden}}",
  create_create_project: "Project aanmaken \u00B7 {n, plural, one {# tegoed} other {# tegoeden}}",
  create_no_problems: "Kon geen problemen vinden. Probeer een duidelijkere foto of een andere pagina.",
  create_no_topics: "Kon geen onderwerpen vinden. Probeer een duidelijkere foto of een ander bestand.",
  create_error: "Er is iets misgegaan. Probeer het opnieuw.",
  create_extract_daily_limit: "Dat zijn alle documenten voor vandaag. Morgen meer.",
  create_video_topic_placeholder: "Video {n} onderwerp, bijv. \"Eigenwaarden en Eigenvectoren\"",
  video_share: "Deel",
  // and made the two indistinguishable.
  video_followup_placeholder: "Vervolgvideo genereren...",
  video_chip_simpler: "Eenvoudiger uitleggen",
  video_chip_harder: "Moeilijker voorbeeld",
  video_chip_real_world: "Gebruik in de echte wereld",
  // spends a credit generating a new one.
  video_ask_title: "Vraag naar dit filmpje",
  video_ask_cta: "Chat hierover",
  video_ask_placeholder: "Stel een vraag...",
  video_ask_thinking: "Denken...",
  video_ask_close: "Dichtbij",
  video_ask_chip_explain: "Leg dat deel uit",
  video_ask_chip_example: "Geef een voorbeeld",
  video_ask_chip_why: "Waarom werkt dat?",
  video_ask_limit_reached: "U heeft de vraaglimiet van vandaag bereikt. Morgen wordt het opnieuw ingesteld.",
  video_up_next: "Volgende",
  video_no_suggested: "Nog geen voorgestelde video's",
  video_untitled: "Naamloze video",
  video_created_recently: "Onlangs gemaakt",
  video_just_now: "Zojuist",
  video_minutes_ago: "{n, plural, one {# minuut} other {# minuten}} geleden",
  video_hours_ago: "{n, plural, one {# uur} other {# uur}} geleden",
  video_days_ago: "{n, plural, one {# dag} other {# dagen}} geleden",
  video_weeks_ago: "{n, plural, one {# week} other {# weken}} geleden",
  video_months_ago: "{n, plural, one {# maand} other {# maanden}} geleden",
  video_years_ago: "{n, plural, one {# jaar} other {# jaar}} geleden",
  video_unknown_date: "Onbekende datum",
  video_download_error: "Er is iets misgegaan. Probeer het opnieuw.",
  // Search Results
  search_no_results: "Geen resultaten gevonden",
  search_no_results_for: "Geen resultaten gevonden voor \"{query}\"",
  search_all_videos: "Zoek alle video's",
  search_enter_term: "Voer een zoekterm in om video's te vinden",
  search_retry: "Probeer opnieuw te zoeken",
  auth_continue_google: "Ga verder met Google",
  // sentence, and the box ships unticked — a pre-ticked box is not consent.
  home_sub_waiver: "Begin meteen met mijn toegang. Ik begrijp dat dit betekent dat ik afstand doe van mijn recht van {days} dagen om me terug te trekken en een terugbetaling te krijgen.",
  home_sub_waiver_required: "Bevestig dit om door te gaan.",
  home_sub_agree_prefix: "Als u doorgaat, gaat u akkoord met onze",
  // floor is 13 — if that clause changes, this string and DIGITAL_CONSENT_AGE move with it.
  auth_min_age: "Je moet {age} of ouder zijn om Magi te gebruiken.",
  auth_agree_prefix: "Door u aan te melden, gaat u akkoord met onze",
  auth_terms: "Servicevoorwaarden",
  auth_and: "En",
  auth_privacy: "Privacybeleid",
  auth_email_optin: "Stuur mij tips en updates",
  // Auth modal (Google + email/password)
  auth_signin_title: "Meld u aan bij Magi",
  auth_signin_desc: "Ga verder waar je was gebleven.",
  auth_signup_title: "Maak uw account aan",
  auth_signup_desc: "Gratis om te beginnen, geen kaart nodig.",
  auth_or: "of",
  auth_continue_email: "Ga verder met e-mail",
  auth_signing_in: "Inloggen…",
  auth_working: "Even…",
  auth_email_placeholder: "E-mailadres",
  auth_password_placeholder: "Wachtwoord",
  auth_signin_submit: "Log in",
  auth_signup_submit: "Account aanmaken",
  auth_no_account: "Nieuw hier?",
  auth_signup_link: "Maak een account aan",
  auth_have_account: "Heeft u al een account?",
  auth_signin_link: "Log in",
  auth_forgot_password: "Wachtwoord vergeten?",
  auth_reset_title: "Reset uw wachtwoord",
  auth_reset_desc: "We sturen u per e-mail een link waarmee u een nieuwe kunt instellen.",
  auth_reset_submit: "Resetlink verzenden",
  auth_reset_sent: "Controleer uw e-mail voor de resetlink.",
  auth_back_to_signin: "Terug naar inloggen",
  // Full-screen wall shown to a signed-in account that has not confirmed its address.
  verify_wall_title: "Bevestig uw e-mailadres om door te gaan",
  verify_wall_desc: "We hebben een bevestigingslink naar {email} gestuurd. Klik erop en kom dan hier terug.",
  verify_wall_check: "Ik heb het bevestigd",
  verify_wall_checking: "Controleren...",
  verify_wall_still_unverified: "Nog niet bevestigd. Klik op de link in de e-mail en probeer het opnieuw.",
  verify_wall_resend: "Stuur de link opnieuw",
  verify_wall_resent: "Verstuurd. Controleer uw inbox en uw spammap.",
  verify_wall_wrong_account: "Verkeerde rekening? Meld u af",
  // The screen the confirmation LINK lands on, replacing Firebase's unbranded handler page.
  verify_action_working_title: "Bevestiging van uw e-mail",
  verify_action_working_desc: "Eén moment.",
  verify_action_done_title: "Je bent er helemaal klaar voor",
  verify_action_done_desc: "Uw e-mail is bevestigd. Welkom bij Magi.",
  verify_action_done_cta: "Begin met leren",
  verify_action_failed_title: "Die link werkte niet",
  verify_action_failed_desc: "Het kan zijn dat het al gebruikt is, of dat het verlopen is. Ga terug en stuur jezelf een nieuwe.",
  verify_action_failed_cta: "Terug naar Magi",
  // Wall copy — each surface names what signing in actually gets you
  auth_watch_title: "Log in om te kijken",
  auth_watch_desc: "Maak een gratis account aan om deze video af te spelen.",
  auth_watch_ready_title: "Je video is klaar",
  auth_watch_ready_desc: "Meld u aan om het te bekijken. Het wordt opgeslagen in uw account.",
  // rather than saying "sign in" twice — the specific ask converts, the generic one nags.
  auth_download_title: "Log in om te downloaden",
  auth_download_desc: "Maak een gratis account aan om deze video op te slaan.",
  auth_ask_title: "Log in om te vragen",
  auth_ask_desc: "Maak een gratis account aan om naar deze video te vragen.",
  auth_browse_title: "Meld u aan om te bladeren",
  auth_browse_desc: "Maak een gratis account aan om elke les te verkennen.",
  auth_workspace_title: "Meld u aan om uw werk te bekijken",
  auth_workspace_desc: "Je lessen en projecten staan ​​in je account.",
  auth_generate_title: "Log in om door te gaan met creëren",
  auth_generate_desc: "Gratis accounts krijgen elke dag een video.",
  video_restricted: "Deze video is nog niet beschikbaar.",
  // Share sheet
  share_title: "Deel deze video",
  share_desc_mobile: "Plaats het in je verhaal, stuur het naar een vriend of kopieer de link.",
  share_desc_desktop: "Kopieer de link of download de video om deze vanaf je telefoon te plaatsen.",
  share_to_apps: "Deel op Instagram en meer",
  share_copy_link: "Kopieer link",
  share_copied: "Link gekopieerd",
  share_download: "Video downloaden",
  share_preparing: "Klaarmaken…",
  share_watermark_note: "Gedeelde video's zijn onder meer magiacademy.com",
  // Welcome Modal (post-signup)
  welcome_title: "Welkom bij Magie",
  welcome_subtitle: "Je hebt 4 gratis video's om te beginnen.",
  welcome_optin_reward: "+1 gratis video",
  welcome_continue: "Doorgaan",
  age_gate_continue: "Doorgaan",
  age_gate_saving: "Besparing...",
  // Landing Page
  landing_hero: "Typ een onderwerp.",
  landing_hero2: "Neem een ​​videoles.",
  landing_subtitle: "Magi verandert elk onderwerp binnen enkele minuten in een prachtig geanimeerde, verteld video. Geen filmen, geen montage, geen expertise nodig.",
  landing_signup_google: "Meld u aan bij Google",
  landing_signing_in: "Aanmelden...",
  landing_chat_bubble: "Hoe gebruikt GPS de relativiteitstheorie?",
  landing_stats_title: "Vertrouwd door leerlingen over de hele wereld",
  landing_stat_videos: "3.000+",
  landing_stat_videos_desc: "Video's gegenereerd",
  landing_stat_languages_desc: "Talen",
  landing_stat_speed: "~1 minuut",
  landing_stat_speed_desc: "Generatie tijd",
  landing_feature_lecture_title: "Laat uw aantekeningen achter, ontvang video's",
  landing_feature_lecture_desc: "Upload uw dia's of notities. Magi haalt elk onderwerp tevoorschijn en genereert voor elk onderwerp een video-uitleg.",
  landing_feature_hw_title: "Zit je vast aan huiswerk? Upload het.",
  landing_feature_hw_desc: "Zet een reeks problemen neer en Magi haalt elk probleem eruit en leidt je vervolgens door de oplossing in een stapsgewijze video.",
  landing_feature_chat_title: "Stel vragen terwijl je kijkt",
  landing_feature_chat_desc: "Elke video wordt geleverd met een AI-leraar waarmee je kunt chatten. Stel vervolgvragen, krijg diepere uitleg of vraag een nieuwe video aan over een specifiek onderdeel dat je beter wilt begrijpen.",
  landing_feature_lang_title: "Leer in uw taal",
  landing_feature_lang_desc: "Magi genereert video's in het Engels, Spaans, Hindi, Chinees, Japans en meer. Typ uw onderwerp in elke taal en ontvang een volledig verteld les terug in die taal.",
  landing_cta_title: "Begin binnen enkele seconden met leren",
  landing_cta_google: "Ga verder met Google",
  // Onboarding Bubbles
  onboarding_step1: "Dit is geen chatbot: typ een onderwerp en ik genereer een volledige videoles voor je!",
  onboarding_step2: "Of stuur een pdf of foto naar \u2014 Ik zet elk probleem om in een stapsgewijze video-oplossing",
  onboarding_step3: "Druk op Go en je video wordt in de wachtrij geplaatst. Je kunt blijven browsen terwijl het wordt weergegeven!",
  onboarding_generating: "Dit is jouw les die binnen een paar minuten wordt getrokken. Blijf browsen als je wilt; Het zal hier landen als het klaar is.",
  onboarding_skip: "Overslaan",
  onboarding_next: "Volgende",
  onboarding_done: "Begrepen!",
  // Generating Cards Row
  generating_label: "Genereren",
  // Lecture Session (Self Study)
  lecture_loading: "Laden...",
  lecture_fallback_title: "Lezing",
  lecture_building: "Bouwvideo...",
  lecture_building_time: "Dit duurt meestal 2-4 minuten",
  lecture_failed: "Het genereren van video is mislukt",
  lecture_no_video: "Nog geen video",
  lecture_followup: "Vervolg",
  lecture_now_playing: "Nu aan het spelen",
  lecture_tab_videos: "Video's",
  lecture_tab_chat: "Chatten",
  lecture_chat_empty: "Vraag alles over dit onderwerp",
  lecture_chat_chip1: "Leg het eenvoudig uit",
  lecture_chat_chip2: "Geef een voorbeeld",
  lecture_chat_chip3: "Waarom is dit nuttig?",
  lecture_chat_placeholder: "Vraag over dit onderwerp...",
  lecture_followup_placeholder: "Voeg een vervolgvideo toe...",
  lecture_chat_error: "Sorry, ik kon dat niet verwerken. Probeer het opnieuw.",
  lecture_chat_generic_error: "Er is iets misgegaan. Probeer het opnieuw.",
  // Home shortcuts — square cards that jump to the Workspace composer preset to a mode
  home_sc_hw_title: "Huiswerk pdf",
  home_sc_hw_desc: "Upload een probleemset en ontvang voor elke vraag een uitgewerkte video",
  home_sc_lecture_title: "Lezing pdf",
  home_sc_lecture_desc: "Verander dia's of aantekeningen in een reeks lessen",
  home_sc_course_title: "Maak een cursus",
  home_sc_course_desc: "Plan een reeks lessen over één onderwerp",
  // Misc
  generic_error: "Er is iets misgegaan. Probeer het opnieuw.",
  loading: "Laden...",
};

export default nl;
